import VueDragscroll from 'vue-dragscroll'

/**
 * @param {import('@quasar/app-webpack').BootFileParams} params
 */
export default async ({ app }) => {
  app.use(VueDragscroll)
}
